module.exports = __webpack_public_path__ + "static/media/icon_instrument_unknown.2218bd45.svg";